module.exports = __webpack_public_path__ + "static/media/image28.6cac645f.jpeg";